import { c as _c } from "react/compiler-runtime";
import { BookingsInterface } from 'modules/calendar/bookings/types/booking-details-interface';
import { EventTypeEnum } from 'modules/calendar/events/enums/event-type-enum';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import { BOOKINGS_API } from '../api/bookings-api';
import { BookingRescheduleInterface } from '../types/bookings-interface';
export function useBookingAction() {
  const $ = _c(13);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.patch
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher: fetcherPatch,
    isFetching
  } = useFetch(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.delete
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    fetcher: deleteFetcher
  } = useFetch(t1);
  let t2;
  if ($[2] !== fetcherPatch) {
    t2 = (data, eventTypeGroup) => fetcherPatch(`${BOOKINGS_API}/${eventTypeGroup === EventTypeEnum.Group ? "group/reschedule" : "reschedule"}`, data);
    $[2] = fetcherPatch;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const rescheduleBooking = t2;
  let t3;
  if ($[4] !== fetcherPatch) {
    t3 = (id, eventTypeGroup_0) => fetcherPatch(`${BOOKINGS_API}/${eventTypeGroup_0 === EventTypeEnum.Group ? `group/cancel?id=${id}` : `cancel?id=${id}`}`);
    $[4] = fetcherPatch;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const cancelBooking = t3;
  let t4;
  if ($[6] !== deleteFetcher) {
    t4 = id_0 => deleteFetcher(`${BOOKINGS_API}/delete?id=${id_0}`);
    $[6] = deleteFetcher;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const deleteBooking = t4;
  let t5;
  if ($[8] !== cancelBooking || $[9] !== deleteBooking || $[10] !== isFetching || $[11] !== rescheduleBooking) {
    t5 = {
      rescheduleBooking,
      isFetchingReschedule: isFetching,
      cancelBooking,
      deleteBooking
    };
    $[8] = cancelBooking;
    $[9] = deleteBooking;
    $[10] = isFetching;
    $[11] = rescheduleBooking;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}